import { useEffect, useState } from "react";
import { apiAcceptPolicies } from "../services/authService";
import PolicyLinks from "./policy/PolicyLinks";
import "../App.css";

// Generic — data-driven off `requiredPolicies` (from a policy_acceptance_required
// response), not hardcoded to Rules. Today's only caller passes Rules-only
// content; Terms/Privacy add more entries later with no change here.
export default function PolicyUpdateModal({ isOpen, requiredPolicies, onClose, onAccepted }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) setError("");
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    function handleKey(e) { if (e.key === "Escape") onClose?.(); }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!isOpen || !requiredPolicies?.length) return null;

  async function handleAccept() {
    setLoading(true);
    setError("");
    try {
      await apiAcceptPolicies(requiredPolicies.map((p) => p.documentType), "policy_update_modal");
      onAccepted?.();
    } catch (err) {
      setError(err.message || "We couldn't save your acknowledgment. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="policy-update-title">
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="auth-title" id="policy-update-title">Our Rules Have Been Updated</h2>
        <p className="auth-context-message">
          Who Would Win now uses automated moderation and progressive account enforcement to help keep the service safe.
          Requests that violate our Rules may be blocked, and repeated or serious violations can result in warnings,
          temporary restrictions, or suspension. Please review the Rules & Code of Conduct before continuing.
        </p>
        <PolicyLinks policies={requiredPolicies} />
        {error && <p className="auth-error">{error}</p>}
        <button className="auth-submit" onClick={handleAccept} disabled={loading}>
          {loading ? "Saving…" : "I Understand & Continue"}
        </button>
      </div>
    </div>
  );
}
